<template>
    <div v-if="driverId" class="quick-actions">
        <button
            type="button"
            class="quick-action"
            v-b-tooltip.hover.top="__('view_infringements')"
            :aria-label="__('view_infringements')"
            @click="openGoliaInfringements({ driverId })"
        >
            <i class="fa-solid fa-record-vinyl"></i>
        </button>
        <button
            type="button"
            class="quick-action"
            v-b-tooltip.hover.top="__('view_tachograph_activities')"
            :aria-label="__('view_tachograph_activities')"
            @click="openGoliaTachographActivities({ driverId })"
        >
            <i class="fa-regular fa-gauge-high"></i>
        </button>
    </div>
</template>

<script>
import goliaLegacyLinks from '@/mixins/goliaLegacyLinks'

export default {
    name: 'DriverQuickActions',
    mixins: [goliaLegacyLinks],
    props: {
        driver: {
            type: Object,
            default: null
        }
    },
    computed: {
        driverId() {
            const id = this.driver?.id ?? this.driver?.id_golia
            return id && id > 1 ? id : null
        }
    }
}
</script>

<style scoped lang="scss">
@use './styles/quickActions.scss';
</style>
